import React from 'react'

const Index = () => {
  return (
    <div>
      
	<section id="sidebar">
		<a href="#" class="brand">
			<i class='bx bxs-smile'></i>
			<span class="text">Admin-NGS</span>
		</a>
		<ul class="side-menu top">
			<li class="active">
				<a href="/admin">
					<i class='bx bxs-dashboard' ></i>
					<span class="text">Dashboard</span>
				</a>
			</li>
			<li>
				<a href="/posts">
					<i class='bx bxs-shopping-bag-alt' ></i>
					<span class="text">Posts</span>
				</a>
			</li>
			<li>
				<a href="/mensagem">
					<i class='bx bxs-shopping-bag-alt' ></i>
					<span class="text">Mensagens</span>
				</a>
			</li>
			<li>
				<a href="#">
					<i class='bx bxs-doughnut-chart' ></i>
					<span class="text">Analytics</span>
				</a>
			</li>
			<li>
				<a href="/agendados">
					<i class='bx bxs-message-dots' ></i>
					<span class="text">Agendados</span>
				</a>
			</li>
			<li>
				<a href="/team">
					<i class='bx bxs-group' ></i>
					<span class="text">Team</span>
				</a>
			</li>
		</ul>
		<ul class="side-menu">
			<li>
				<a href="/setting">
					<i class='bx bxs-cog' ></i>
					<span class="text">Settings</span>
				</a>
			</li>
			<li>
				<a href="/menu-consulta">
					<i class='bx bxs-cog' ></i>
					<span class="text">menu consulta</span>
				</a>
			</li>
<li>
	<a href='/app/admin/dashboard'>
	<i class='bx bxs-cog'></i>
	<span class="text">Processos</span>
	</a>
</li>
			<li>
				<a href="/admin/lp/landpages">
					<i class='bx bxs-cog' ></i>
					<span class="text">LandPages</span>
				</a>
			</li>
			<li>
				<a href="#" class="logout">
					<i class='bx bxs-log-out-circle' ></i>
					<span class="text">Logout</span>
				</a>
			</li>
		</ul>
	</section>
	

    </div>
  )
}

export default Index
